import { render, staticRenderFns } from "./AppParallax.vue?vue&type=template&id=bd00dd82&"
import script from "./AppParallax.vue?vue&type=script&lang=js&"
export * from "./AppParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports